import PropTypes from 'prop-types';
import DefaultTemplate from '../Default/DefaultTemplate';

const TextLateral = (props) => {
  return <DefaultTemplate {...props} textLateral />;
};

TextLateral.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  isEditMode: PropTypes.bool,
};

export default TextLateral;
